export const maxLogWriteAttempts = 10;
export const retryIntervalInMillis = 30_000;
export const maxQueueLength = 10_000;
export const maxDeadLetterQueueLength = 10_000;
